import requireAuthorization from "@/routes/helper/requireAuthorization";
import i18n from "@/i18n";
import { RoleEnum } from "@/store/authentication/types";

export default [
    {
        path: "/contracts",
        name: "contracts",
        component: () => import("@/components/contracts/_Contracts.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            role: RoleEnum.ContractsRole,
            breadcrumbs: {
                icon: "profile-icon",
                paths: [
                    ["/contracts", i18n.t("contracts")]
                ]
            }
        }
    },
    {
        path: "/contracts/create",
        name: "ContractCreateForm",
        component: () => import("@/components/contracts/_ContractForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            role: RoleEnum.ContractsRole,
            breadcrumbs: {
                icon: "profile-icon",
                paths: [
                    ["/editorProfiles", i18n.t("editorProfiles.title")],
                    ["", i18n.t("editorProfiles.createTitle")]
                ]
            }
        },
        props: true
    },
    {
        path: "/contracts/update/:contractId",
        name: "ContractUpdateForm",
        component: () => import("@/components/contracts/_ContractForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            role: RoleEnum.ContractsRole,
            breadcrumbs: {
                icon: "profile-icon",
                paths: [
                    ["/editorProfiles", i18n.t("editorProfiles.title")],
                    ["", i18n.t("editorProfiles.editTitle")]
                ]
            }
        },
        props: true
    }
];
